<template>
    <div v-if="$store.loadedApp" id="app" :dir="$store.selectedAppLanguage == 'ar' ? 'rtl' : 'ltr'">
        <div v-if="!$store.showMainErrorPage" class="app-wrapper">
            <router-view />
            <ChangeUserImgPage v-if="$store.showChangeUserImgPage" />
        </div>
        <div v-else class="main-error-page-container">
            <div class="main-error-page-wrapper">
                <div class="main-error-page-text-container">
                    <p class="main-error-page-text">{{ $t('something_went_wrong_try_again') }}</p>
                </div>
                <div class="reload-page-btn-container">
                    <div class="reload-page-btn" @click="reloadPage">{{ $t('reload') }}</div>
                </div>
            </div>
        </div>
        <ErrorPopupComponent />
    </div>
</template>

<script>
/* eslint-disable */
import ChangeUserImgPage from './components/home/ChangeUserImgPage.vue';
import ErrorPopupComponent from './components/ErrorPopupComponent.vue';
const { getAppTranslation } = require('./actions/onloadActions');
export default {
    name: "app",
    components: {
        ChangeUserImgPage,
        ErrorPopupComponent,
    },
    data() {
        return {
            requestSource: this.$store.requestSource,
            componentKey: 0,
        }
    },
    methods: {
        reloadPage: function () {
            this.$store.showMainErrorPage = false;
            this.$router.push('/home');
        },
        reRenderComponent() {
            // console.log("Rerender component from vue app...");
            // console.log("this.$store.loadedApp: " + this.$store.loadedApp);
            this.componentKey += 1;
        },
    },
    async created() {
        // const browserLanguage = navigator.language.slice(0,2);
        // console.log("Browser language:", browserLanguage);

        // Get the language that should be used in the app.
        const browserLanguage = navigator.language.slice(0,2);
        // console.log("Browser language:", browserLanguage);
        const localStorageUser = JSON.parse(localStorage.getItem('user'));
        if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
            // Check if the browser's language is Dutch or not.
            // if (browserLanguage.toLowerCase() == 'nl') {
            // this.$store.selectedAppLanguage = browserLanguage.toLowerCase();
            // }
            // else {
            // this.$store.selectedAppLanguage = 'en';
            // }

            this.$store.changeAppLanguage(browserLanguage);
        }

        // console.log("appLanguageChangedBeforeLogin: " + this.$store.appLanguageChangedBeforeLogin);

        window.myData = {
            deleteCookie: this.$store.deleteCookie,
            resetStoreUser: this.$store.resetStoreUser,
            logOut: this.$store.logOut,
            reRenderComponent: this.reRenderComponent,
            changeAppLanguageFromWebView: (lang) => this.$store.changeAppLanguage(lang),
            loadAppPageFromWebView: () => {
                this.$store.loadedApp = true;
                // console.log("this.$store.loadedApp: " + this.$store.loadedApp);
                // console.log("this.$store.selectedAppLanguage: " + this.$store.selectedAppLanguage);
            },
            keyboardVisibilityOnWebView: (status) => {
                // console.log("Keyboard visible: " + status);
                // console.log(this.$store);
                // console.log("request source: " + this.$store.requestSource);


                if (this.$store.requestSource.includes("webView")) {
                    const popupMsgContainer = document.querySelector(".popup-msg-container");
                    // console.log(popupMsgContainer);
                    if (popupMsgContainer) {
                        if (status) {
                            popupMsgContainer.style.marginBottom = '300px';
                        }
                        else {
                            popupMsgContainer.style.marginBottom = '20px';
                        }
                        popupMsgContainer.scrollIntoView({ behavior: 'smooth' });
                    }
                }
            }
        };

        // // Get the user agent string from the HTTP headers
        // const userAgent = navigator.userAgent;

        // // Check if the user agent string contains specific keywords
        // if (userAgent.includes("webView")) {
        //     // This suggests the website is being opened in a WebView (likely a mobile app)
        //     this.$store.requestSource = userAgent;
        // } else {
        //     // This suggests the website is being opened in a regular web browser
        //     this.$store.requestSource = "browser";
        // }

        try {
            const translationResponse = await getAppTranslation();
            // console.log("translationResponse...");
            // console.log(translationResponse);
            if (translationResponse.status) {
                this.$store.allLanguages = translationResponse.data;
            }
            else {
                this.$store.allLanguages = this.$i18n.messages;
            }
        } catch (err) {
            console.error('Error loading translations:', err);
            this.$store.allLanguages = this.$i18n.messages;
        }

        // this.$store.allLanguages = this.$i18n.messages;

        // this.$i18n.locale = this.$store.selectedAppLanguage;
        // this.$i18n.setLocaleMessage(this.$i18n.locale, this.$i18n.messages[this.$i18n.locale]);


        // console.log("this.$store.selectedAppLanguage from App.vue: " + this.$store.selectedAppLanguage);

        // console.log("this.$store.requestSource: " + this.$store.requestSource);

        if (!this.$store.requestSource.includes("webView")) {
            this.$store.loadedApp = true;

            // this.$store.flutterAppMustBeUpdated = true;
            // this.$store.showErrorPopup = true;
            // this.$store.errorPopupTitle = 'new_version_available';
        }
        else {
            try {
                if (window.flutter_load_app_lang_when_startup) {
                    await window.flutter_load_app_lang_when_startup.postMessage(JSON.stringify({appLang: null}));
                } else {
                    console.warn('Flutter bridge method not available');
                    this.$store.loadedApp = true;
                }
            } catch (err) {
                console.error('Error calling Flutter bridge:', err);
                this.$store.loadedApp = true;
            }

            if (this.$store.requestSource.length < 8) {
                this.$store.flutterAppMustBeUpdated = true;
                this.$store.showErrorPopup = true;
                this.$store.errorPopupTitle = 'new_version_available';
            }
        }
    },
}
</script>

<style>
@font-face {
    font-family: 'VAG Rounded Std';
    src: url('./assets/fonts/rond-heavy.woff2') format('woff2');
}

@font-face {
    font-family: 'Open Sans Std';
    src: url('./assets/fonts/opensans-regular.woff2') format('woff2');
}

.fit20-font-light {
    font-family: 'VAG Rounded Std' !important;

}

.fit20-font {
    font-family: 'VAG Rounded Std' !important;
}

@keyframes appear-main {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

* {
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
    user-select: none;
    /* chrome and Opera */
    -moz-user-select: none;
    /* Firefox */
    -webkit-text-select: none;
    /* IOS Safari */
    -webkit-user-select: none;
    /* Safari */
}

html,
body {
    max-width: 1500px;
    min-width: 280px;
    margin: 0 auto;
    animation: appear-main 2.5s;
    background: #ffffff;
    scroll-behavior: smooth;
}

ul {
    list-style: none;
}

h2 {
    font-family: "VAG Rounded Std", Verdana, Geneva, Tahoma, sans-serif;
}

a {
    all: unset;
    /* Remove all styling from the a tag */
}

p {
    white-space: pre-line;
    /* white-space: pre-wrap; */
}

.red {
    color: #cb061d;
}

.green {
    color: #92d400;
}

.blue {
    color: #009df4;
}



canvas {
    max-height: 300px;
}

.fade {
    /* opacity: 0.4; */
    /* color: #fdfef9 !important; */
}

.activity-page {
    animation: slide linear 0.4s;
}

.card-page-animation {
    animation: machine-page-slide linear 0.4s;
}

/* Works on Firefox */
.scroll-bar {
  /* scrollbar-width: thin;
  scrollbar-color: #009df4 #d6d9d9; */
  overflow-y: auto;
  overflow-x: hidden;
  /* cursor: pointer; */
}

/* Works on Chrome, Edge, and Safari */
.scroll-bar::-webkit-scrollbar {
  width: 3px;
}

.scroll-bar::-webkit-scrollbar-track {
  background: #d6d9d9;
  border-radius: 10px;
}

.scroll-bar::-webkit-scrollbar-thumb {
  background-color: #009df4;
  border-radius: 10px;
}

/* Remove the up and down arrows */
.scroll-bar::-webkit-scrollbar-button {
  display: none;
}

.center-text-with-vag-font {
    transform: translateY(2px);
}

@keyframes machine-page-slide {
    0% {
        transform: translate(-100%, 0%);
    }

    10% {
        transform: translate(-90%, 0%);
    }

    20% {
        transform: translate(-80%, 0%);
    }

    30% {
        transform: translate(-70%, 0%);
    }

    40% {
        transform: translate(-60%, 0%);
    }

    50% {
        transform: translate(-50%, 0%);
    }

    60% {
        transform: translate(-40%, 0%);
    }

    70% {
        transform: translate(-30%, 0%);
    }

    80% {
        transform: translate(-20%, 0%);
    }

    90% {
        transform: translate(-10%, 0%);
    }

    100% {
        transform: translate(0%, 0%);
    }
}

@keyframes slide {
    0% {
        transform: translate(100%, 0%);
    }

    10% {
        transform: translate(90%, 0%);
    }

    20% {
        transform: translate(80%, 0%);
    }

    30% {
        transform: translate(70%, 0%);
    }

    40% {
        transform: translate(60%, 0%);
    }

    50% {
        transform: translate(50%, 0%);
    }

    60% {
        transform: translate(40%, 0%);
    }

    70% {
        transform: translate(30%, 0%);
    }

    80% {
        transform: translate(20%, 0%);
    }

    90% {
        transform: translate(10%, 0%);
    }

    100% {
        transform: translate(0%, 0%);
    }
}

#app {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100vh;
    /* background: url('../assets/bgpattern.webp') center center fixed; */
    /* background-size: cover; */
}

.app-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
}

.main-error-page-container {
    flex: 1;
    width: 100%;
    max-width: 500px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    /* border: 1px solid; */
}

.main-error-page-text {
    font-size: 30px;
    font-family: 'Open Sans Std', sans-serif;
    color: #cb061d;
    text-align: center;
    padding-bottom: 30px;
    white-space: pre-line;
}

.reload-page-btn-container {
    display: flex;
    justify-content: center;
}

.reload-page-btn {
    width: 100%;
    min-width: 200px;
    max-width: 250px;
    color: #fff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 28px;
    text-align: center;
    letter-spacing: 1px;
    padding: 6px 0 10px;
    background: #009df4;
    border: 1px solid #fff;
    border-radius: 30px;
    cursor: pointer;
}

/* ========== Loading spinner ========== */

.circular-progress-indicator {
    border: 5px solid #92d400;
    border-top: 5px solid #616365;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    animation: spin 1.25s linear infinite;
    margin: 0 auto;
}

.spinner {
    width: 50px;
    height: 50px;
    /* display: inline-block; */
    display: flex;
    justify-content: center;
    align-items: center;
    animation: spin 2.2s infinite linear;
}

.spinner img {
    width: 100%;
}

.cropper-view-box,
.cropper-face {
    border-radius: 50% !important;
    outline: 1px solid #92d400 !important;
    outline-color: rgba(146, 212, 0, 0.75) !important;
}

.cropper-line {
    background-color: #92d400 !important;
}

.cropper-point {
    background-color: #92d400;
}

input.blocked {
  pointer-events: none;
  background-color: #eee; /* optional, to show it’s inactive */
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@media only screen and (min-width: 1351px) {

    /* For big screens: */
    body {
        margin: auto;
    }
}

@media (max-width: 767px) {
    .main-error-page-text {
        font-size: 24px;
    }

    .reload-page-btn {
        min-width: 0;
        max-width: 200px;
        font-size: 26px;
    }
}

@media (max-width: 424px) {
    .main-error-page-text {
        font-size: 20px;
    }

    .reload-page-btn {
        min-width: 0;
        max-width: 175px;
        font-size: 24px;
    }
}

@media (max-width: 375px) {
    .main-error-page-text {
        font-size: calc(14px + 1vw);
    }

    .reload-page-btn {
        min-width: 0;
        max-width: 150px;
        font-size: 22px;
    }
}


</style>
